import { Block, Spacer, Video, Image, Spotify } from "../../../../src/components/project/project";
import * as React from 'react';
export default {
  Block,
  Spacer,
  Video,
  Image,
  Spotify,
  React
};